import { styled } from '@mui/material';
import { buttonClasses, default as MuiButton } from '@mui/material/Button';

const Button = styled(MuiButton)(({ theme }) => ({
  [`&.${buttonClasses.sizeMedium}`]: {
    paddingBlock: theme.spacing(1.25),
  },
}));

export default Button;
